import React, { useState, useEffect } from "react";
import { Modal, Button, Table, InputNumber, message } from "antd";
import "../Reporting.scss";
import cancelX from "../../../../Assets/svg/cancelXbutton.svg";
import { httpService } from "../../../../services/httpService.service";
import Done from "../../../../Assets/svg/done.svg";
import exclamationMark from "../../../../Assets/svg/exclamationMark.svg";

const EditModal = ({
  visible,
  onCancel,
  onOk,
  siteVisitCardId,
  visitId,
  setMessage,
}) => {
  const [siteLoader, setSiteLoader] = useState(false);
  const [tableData, setTableData] = useState([]);
  useEffect(() => {
    if (visible && siteVisitCardId) {
      setSiteLoader(true);
      httpService.get(
        `/api/Site/getDataChecksBySiteVisit?siteVisitId=${siteVisitCardId}`,
        (res) => {
          setSiteLoader(false);
          setTableData((res.data || []).filter((row) => row?.target > 0));
        },
        (error) => {
          setSiteLoader(false);
        }
      );
    }
  }, [visible, siteVisitCardId]);

  const handleCancel = () => {
    setTableData([]);
    onCancel();
  };

  const handleEdit = () => {
    if (!siteVisitCardId) return;

    const beneficiaries =
      tableData.find((item) => item.tool === "Beneficiaries Surveys")
        ?.conducted || 0;
    const clients =
      tableData.find((item) => item.tool === "KII Contacts")?.conducted || 0;
    const observation =
      tableData.find((item) => item.tool === "Observation Checklist")
        ?.conducted || 0;

    const updateCostumProperties = tableData
      .filter((item) => item.id)
      .map((item) => ({
        costumPropertyId: item.id,
        conducted: item.conducted || 0,
      }));
    const formattedData = {
      visitId: visitId,
      beneficiariesCountConducted: beneficiaries,
      clientsCountConducted: clients,
      observationChecklistConducted: observation,
      updateCostumProperties,
    };

    setSiteLoader(true);
    httpService.put(
      "/api/Site/updateVisitDataChecks",
      formattedData,
      (res) => {
        setSiteLoader(false);
        const message =
          res?.message ||
          "The data check information has been successfully added to your database.";
        setMessage({
          trigger: true,
          type: "success",
          icon: Done,
          title: `Data Check information added successfully!`,
          text: message,
        });
        setTimeout(() => {
          setMessage({
            trigger: false,
          });
        }, 3000);
        setTableData([]);
        if (onOk) {
          onOk();
        } else {
          onCancel();
        }
      },
      (error) => {
        setSiteLoader(false);
        const errorMessage =
          error?.errors?.[0]?.message ||
          error?.message ||
          "We had a problem adding this data check information to your database, please try again.";

        setMessage({
          trigger: true,
          type: "danger",
          icon: exclamationMark,
          title: "Oops! A problem has occurred!",
          text: errorMessage,
        });

        setTimeout(() => {
          setMessage({
            trigger: false,
          });
        }, 3000);
      }
    );
  };

  const columns = [
    {
      title: "Tool",
      dataIndex: "tool",
      key: "tool",
    },
    {
      title: "Target #",
      dataIndex: "target",
      key: "target",
      align: "center",
    },
    {
      title: "Conducted (Actual)",
      dataIndex: "conducted",
      key: "conducted",
      align: "center",
      render: (_, record, index) => (
        <InputNumber
          min={0}
          value={tableData[index]?.conducted}
          onChange={(value) => {
            const newData = [...tableData];
            newData[index].conducted = value;
            setTableData(newData);
          }}
        />
      ),
    },
  ];

  return (
    <Modal
      title={
        <>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: "20px",
            }}
          >
            <img
              src={cancelX}
              style={{ marginLeft: "auto", cursor: "pointer" }}
              onClick={handleCancel}
              alt="cancelX"
            />
          </div>
          <h2 className="modalHeader">Edit Data Checks</h2>
        </>
      }
      closable={false}
      open={visible}
      onCancel={handleCancel}
      width={800}
      footer={null}
    >
      <div style={{ maxHeight: "400px", overflowY: "auto" }}>
        <Table
          columns={columns}
          dataSource={tableData}
          pagination={false}
          className="tpmTable1"
          loading={siteLoader}
          rowKey="id"
        />
      </div>
      <div className="buttonsModal" style={{ marginTop: "32px" }}>
        <Button className="inviteButtonTPM" key="cancel" onClick={handleCancel}>
          Cancel
        </Button>
        <Button
          className="addButtonTPM"
          key="submit"
          type="primary"
          onClick={handleEdit}
          loading={siteLoader}
        >
          Edit
        </Button>
      </div>
    </Modal>
  );
};

export default EditModal;
